var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lp-whoapp" }, [
    _vm._m(0),
    _c(
      "div",
      {
        staticClass: "grid py-2 px-5 grid grid-cols-4  divide-x",
        attrs: { id: "product-info" }
      },
      [
        _vm._m(1),
        _c(
          "div",
          {
            staticClass: "flex items-center flex-wrap flex-col justify-around"
          },
          [
            _c(
              "svg",
              {
                staticStyle: { width: "20px" },
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  version: "1.1",
                  id: "Capa_1",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 512 512",
                  "xml:space": "preserve"
                }
              },
              [
                _c("g", [
                  _c("g", [
                    _c("path", {
                      attrs: {
                        d:
                          "M472,313v139c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V313H0v139c0,33.084,26.916,60,60,60h392    c33.084,0,60-26.916,60-60V313H472z"
                      }
                    })
                  ])
                ]),
                _c("g", [
                  _c("g", [
                    _c("polygon", {
                      attrs: {
                        points:
                          "352,235.716 276,311.716 276,0 236,0 236,311.716 160,235.716 131.716,264 256,388.284 380.284,264   "
                      }
                    })
                  ])
                ]),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g")
              ]
            ),
            _c("p", { staticClass: "text-gray-500 text-sm\tm-0" }, [
              _vm._v("8.9 MB")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "flex items-center flex-wrap flex-col justify-around"
          },
          [
            _c(
              "svg",
              {
                staticStyle: { width: "20px" },
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  version: "1.1",
                  id: "Capa_1",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 490 490",
                  "xml:space": "preserve"
                }
              },
              [
                _c("g", [
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        attrs: {
                          d:
                            "M17.2,262.1h219c7.7,31.7,36.3,55.3,70.4,55.3s62.6-23.6,70.4-55.3h95.8c9.5,0,17.2-7.7,17.2-17.2s-7.7-17.1-17.2-17.1     H377c-7.7-31.7-36.3-55.3-70.4-55.3s-62.6,23.6-70.4,55.3h-219c-9.5,0-17.2,7.7-17.2,17.1C0.1,254.5,7.8,262.1,17.2,262.1z      M306.6,206.9c21,0,38.1,17.1,38.1,38.1s-17.1,38.1-38.1,38.1S268.4,266,268.4,245S285.5,206.9,306.6,206.9z"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M17.2,428.4h105.1c7.7,31.7,36.3,55.3,70.4,55.3s62.6-23.6,70.4-55.3h209.7c9.5,0,17.2-7.7,17.2-17.1     c0-9.5-7.7-17.2-17.2-17.2H263.1c-7.7-31.7-36.3-55.3-70.4-55.3s-62.6,23.6-70.4,55.3H17.2c-9.5,0-17.2,7.7-17.2,17.2     C0.1,420.7,7.8,428.4,17.2,428.4z M192.7,373.1c21,0,38.1,17.1,38.1,38.1s-17.1,38.1-38.1,38.1c-20.7,0-37.6-16.6-38.1-37.3     c0-0.3,0-0.6,0-0.9s0-0.6,0-0.9C155.1,389.7,172,373.1,192.7,373.1z"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M17.2,95.9h105.1c7.7,31.7,36.3,55.3,70.4,55.3s62.6-23.6,70.4-55.3h209.7c9.5,0,17.2-7.7,17.2-17.2s-7.7-17.1-17.2-17.1     H263.1c-7.7-31.7-36.3-55.3-70.4-55.3s-62.6,23.6-70.4,55.3H17.2C7.7,61.6,0,69.3,0,78.7C0.1,88.2,7.8,95.9,17.2,95.9z      M192.7,40.6c21,0,38.1,17.1,38.1,38.1s-17.1,38.1-38.1,38.1c-20.7,0-37.6-16.6-38.1-37.3c0-0.3,0-0.6,0-0.9s0-0.6,0-0.9     C155.1,57.3,172,40.6,192.7,40.6z"
                        }
                      })
                    ])
                  ]),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g"),
                  _c("g")
                ]),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g"),
                _c("g")
              ]
            ),
            _c("p", { staticClass: "text-gray-500 text-sm m-0" }, [
              _vm._v("PEGI 3")
            ])
          ]
        ),
        _vm._m(2)
      ]
    ),
    _c(
      "a",
      {
        staticClass:
          "block bg-green-700 m-5 text-white\tp-2 rounded-md text-center",
        attrs: { id: "download", href: "#" },
        on: {
          click: function($event) {
            return _vm.sendTrack()
          }
        }
      },
      [_vm._v("Install")]
    ),
    _c(
      "ul",
      {
        staticClass: "overflow-x-auto overflow-y-hidden mx-5 flex pb-4 mb-0",
        attrs: { id: "product-screenshot" }
      },
      [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.sendTrack()
              }
            }
          },
          [_vm._m(3)]
        ),
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.sendTrack()
              }
            }
          },
          [_vm._m(4)]
        ),
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.sendTrack()
              }
            }
          },
          [_vm._m(5)]
        )
      ]
    ),
    _vm._m(6),
    _vm._m(7)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "grid p-5 grid grid-flow-col auto-cols-auto gap-3",
        attrs: { id: "product-hero" }
      },
      [
        _c("figure", { staticClass: "overflow-hidden flex justify-start" }, [
          _c("img", {
            staticClass: "object-cover rounded-3xl h-20 w-20",
            attrs: {
              src:
                "https://play-lh.googleusercontent.com/dyh_wW778FQu_2tmoTmGykGva_DW9mUTFCF54EGLL-g293VLdsvM-ijmAoxqVlq6uHjJ=s200",
              alt: ""
            }
          })
        ]),
        _c("div", { staticClass: "flex flex-col justify-center w-11/12" }, [
          _c("h2", { staticClass: "text-3xl font-normal\ttext-black m-0" }, [
            _vm._v("Who-Caller ID, People & Phone Lookup, Spam Block")
          ]),
          _c(
            "h4",
            { staticClass: "text-green-700 text-base\tfont-normal m-0" },
            [_vm._v("Cascadia")]
          ),
          _c(
            "p",
            {
              staticClass: "text-gray-500 m-0",
              staticStyle: { "font-size": "12px" }
            },
            [_vm._v("In-app Purchases")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex items-center flex-wrap flex-col justify-around" },
      [
        _c("div", { staticClass: "text-black" }, [_vm._v("4.6 ★")]),
        _c("p", { staticClass: "text-gray-500 text-sm m-0" }, [
          _vm._v("90K reviews")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex items-center flex-wrap flex-col justify-around" },
      [
        _c("div", { staticClass: "text-black" }, [_vm._v("4.5M")]),
        _c("p", { staticClass: "text-gray-500 text-sm m-0" }, [
          _vm._v("downloads")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      { staticClass: "flex-shrink-0 rounded-lg mr-2 overflow-hidden border" },
      [
        _c("img", {
          attrs: {
            src:
              "https://play-lh.googleusercontent.com/iW1A1-IzIg7Ny5uDkOu6ck26QS3x7t2IwnmeO6shsqAKdd5yykcGdPhzfokIZMOTEZw=w3200-h1566-rw",
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      { staticClass: "flex-shrink-0 rounded-lg\tmr-2 overflow-hidden border" },
      [
        _c("img", {
          attrs: {
            src:
              "https://play-lh.googleusercontent.com/GdkI_mbNUrHBbQDbfrylDYa31iTV7m_3pIU0cbqkRvZstiY2QGBgRp6-dnmPAqI_j7U=w3200-h1566-rw",
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      { staticClass: "flex-shrink-0 rounded-lg\tmr-2 overflow-hidden border" },
      [
        _c("img", {
          attrs: {
            src:
              "https://play-lh.googleusercontent.com/G_8u1TyuSYRIyhOjARfpq4QuAyPd0EUuy0vND4pM23jJ6xWCv58nfyzg8WYsShFFggfp=w3200-h1566-rw",
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-5", attrs: { id: "about" } }, [
      _c("h2", { staticClass: "font-semibold text-xl mb-3 text-black" }, [
        _vm._v("About this app")
      ]),
      _c("p", { staticClass: "text-gray-500 text-sm m-0" }, [
        _vm._v(
          "\n        Detect & Block Scam, Telemarketer, Fraud & Robocalls - Find out who is calling\n      "
        )
      ]),
      _c("ul", { staticClass: "flex py-2 items-center mt-3 mb-0" }, [
        _c("li", { staticClass: "border py-1 px-2 mb-2 rounded-full mr-2" }, [
          _c("a", { staticClass: "text-gray-500", attrs: { href: "" } }, [
            _vm._v("Communication")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-5", attrs: { id: "rating" } }, [
      _c("h2", { staticClass: "font-semibold text-xl mb-3 text-black" }, [
        _vm._v("Rating and Reviews")
      ]),
      _c("div", { staticClass: "grid grid-cols-3 gap-4" }, [
        _c(
          "div",
          {
            staticClass: "flex flex-col items-start",
            attrs: { id: "rating__general" }
          },
          [
            _c("h5", { staticClass: "text-6xl text-black mb-0 font-normal" }, [
              _vm._v("4.6")
            ]),
            _c("ul", { staticClass: "flex mb-0" }, [
              _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
              _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
              _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
              _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
              _c("li", { staticClass: "text-gray-300" }, [_vm._v("★")])
            ]),
            _c("span", { staticClass: "text-gray-500 font-light self-start" }, [
              _vm._v("1.443")
            ])
          ]
        ),
        _c("div", { staticClass: "col-span-2" }, [
          _c("ul", [
            _c("li", { staticClass: "flex auto-cols-auto items-center" }, [
              _c("span", { staticClass: "mr-2 font-light text-sm" }, [
                _vm._v("5")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "w-full bg-gray-300 rounded-full relative overflow-hidden h-3"
                },
                [
                  _c("span", {
                    staticClass:
                      "absolute left-0 h-full\ttop-0 bg-green-700 rounded-full",
                    staticStyle: { width: "88%" }
                  })
                ]
              )
            ]),
            _c("li", { staticClass: "flex auto-cols-auto items-center" }, [
              _c("span", { staticClass: "mr-2 font-light text-sm" }, [
                _vm._v("4")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "w-full bg-gray-300 rounded-full relative overflow-hidden h-3"
                },
                [
                  _c("span", {
                    staticClass:
                      "absolute left-0 h-full\ttop-0  bg-green-700 rounded-full",
                    staticStyle: { width: "65%" }
                  })
                ]
              )
            ]),
            _c("li", { staticClass: "flex auto-cols-auto items-center" }, [
              _c("span", { staticClass: "mr-2 font-light text-sm" }, [
                _vm._v("3")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "w-full bg-gray-300 rounded-full relative overflow-hidden h-3"
                },
                [
                  _c("span", {
                    staticClass:
                      "absolute left-0 h-full\ttop-0 bg-green-700 rounded-full",
                    staticStyle: { width: "26%" }
                  })
                ]
              )
            ]),
            _c("li", { staticClass: "flex auto-cols-auto items-center" }, [
              _c("span", { staticClass: "mr-2 font-light text-sm" }, [
                _vm._v("2")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "w-full bg-gray-300 rounded-full relative overflow-hidden h-3"
                },
                [
                  _c("span", {
                    staticClass:
                      "absolute left-0 h-full\ttop-0 bg-green-700 rounded-full",
                    staticStyle: { width: "14%" }
                  })
                ]
              )
            ]),
            _c("li", { staticClass: "flex auto-cols-auto items-center" }, [
              _c("span", { staticClass: "mr-2 font-light text-sm" }, [
                _vm._v("1")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "w-full bg-gray-300 rounded-full relative overflow-hidden h-3"
                },
                [
                  _c("span", {
                    staticClass:
                      "absolute left-0 h-full\ttop-0 bg-green-700 rounded-full",
                    staticStyle: { width: "10%" }
                  })
                ]
              )
            ])
          ])
        ])
      ]),
      _c(
        "ul",
        { staticClass: "py-6 divide-y mb-0", attrs: { id: "review-list" } },
        [
          _c("li", { staticClass: "flex flex-wrap flex-col pb-5 pt-5" }, [
            _c("figure", { staticClass: "flex items-center mb-3" }, [
              _c("img", {
                staticClass: "rounded-full object-cover w-10 h-10 mr-5",
                attrs: {
                  src:
                    "https://play-lh.googleusercontent.com/a-/AOh14Gg1W3gp3zI4MqivNaqScKOEbhcmoYL2N1AoCYkwmA=w48-h48-n",
                  alt: ""
                }
              }),
              _c("figcaption", { staticClass: "text-gray-900" }, [
                _vm._v("Erica")
              ])
            ]),
            _c("div", { staticClass: "flex items-center" }, [
              _c("ul", { staticClass: "flex" }, [
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")])
              ]),
              _c("span", { staticClass: "text-gray-500 text-sm ml-3" }, [
                _vm._v("07/03/2021")
              ])
            ]),
            _c("p", { staticClass: "text-gray-500 text-sm mt-3 mb-0" }, [
              _vm._v(
                "\n            Lately there are a lot of unknown numbers, thanks to Who I know the number tags and can be more careful\n          "
              )
            ])
          ]),
          _c("li", { staticClass: "flex flex-wrap flex-col pb-5 pt-5" }, [
            _c("figure", { staticClass: "flex items-center mb-3" }, [
              _c("img", {
                staticClass: "rounded-full object-cover w-10 h-10 mr-5",
                attrs: {
                  src:
                    "https://play-lh.googleusercontent.com/a-/AOh14GgjID95rp2pw99mSs0QQNXANHh_TOQtKwB9F8-dEg=w96-h96-n-rw",
                  alt: ""
                }
              }),
              _c("figcaption", { staticClass: "text-gray-900" }, [
                _vm._v("Sangram Parida")
              ])
            ]),
            _c("div", { staticClass: "flex items-center" }, [
              _c("ul", { staticClass: "flex" }, [
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-gray-300" }, [_vm._v("★")])
              ]),
              _c("span", { staticClass: "text-gray-500 text-sm ml-3" }, [
                _vm._v("12/02/2021")
              ])
            ]),
            _c("p", { staticClass: "text-gray-500 text-sm mt-3 mb-0" }, [
              _vm._v(
                "\n            This app is good. When there's a call from unknown number it always has a warning if it's scam or not. Ok, i like it.\n          "
              )
            ])
          ]),
          _c("li", { staticClass: "flex flex-wrap flex-col pb-5 pt-5" }, [
            _c("figure", { staticClass: "flex items-center mb-3" }, [
              _c("img", {
                staticClass: "rounded-full object-cover w-10 h-10 mr-5",
                attrs: {
                  src:
                    "https://play-lh.googleusercontent.com/a-/AOh14GhTK9W6s36fTfe9_6tuNExMksfMZTZ76eImb9Coeg=w96-h96-n-rw",
                  alt: ""
                }
              }),
              _c("figcaption", { staticClass: "text-gray-900" }, [
                _vm._v("aleya dayana")
              ])
            ]),
            _c("div", { staticClass: "flex items-center" }, [
              _c("ul", { staticClass: "flex" }, [
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")]),
                _c("li", { staticClass: "text-green-700" }, [_vm._v("★")])
              ]),
              _c("span", { staticClass: "text-gray-500 text-sm ml-3" }, [
                _vm._v("18/01/2021")
              ])
            ]),
            _c("p", { staticClass: "text-gray-500 text-sm mt-3 mb-0" }, [
              _vm._v(
                "\n            Wow.... amazing!!! After i use this app for the first time,, the benefits are immediate, as the application of content can track an unknown number and can automatically block it out😆😆 I'm very like this app and very recommended this app for take care all of your private information 🐱\n          "
              )
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b33af994", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b33af994","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/lp_whoapp/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b33af994","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/lp_whoapp/Index.vue
// module chunks = 2 3 4